/**
 * The form two label names are compared in.
 *
 * Case-insensitive, matching the uniqueness rule the backend enforces (spec 063
 * FR-002). Written here so the picker's "does this already exist" check and the
 * API's conflict check agree — if they diverged, the picker would offer to
 * create a label the server then refuses.
 */
export function normalizeForCompare(name: string): string {
  return name.trim().toLocaleLowerCase();
}

/**
 * The labels whose names contain `query`, case- and accent-insensitively.
 *
 * Extracted rather than inlined in a component because two controls filter the
 * same vocabulary the same way — the task picker and the board filter — and a
 * derived value that decides what a reader can find is not something to leave
 * untested in a render body.
 *
 * An empty or blank query matches everything: a filter nobody has typed into is
 * not a filter.
 */
export function matchLabelsByName<T extends { name: string }>(
  labels: readonly T[],
  query: string,
): readonly T[] {
  const needle = normalizeForCompare(query);
  if (!needle) return labels;
  return labels.filter((label) =>
    normalizeForCompare(label.name).includes(needle),
  );
}
